export enum TimeOutEnum {
  TOAST_HIDE_TIME_OUT  = 10000,
  TABLE_REFRESH_TIME_OUT = 500
}
